(function documentControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentShareController', [
            '$scope', 'errorsExtend', 'documentService', '$stateParams', '$state', '$translate',
    function documentVersionsController($scope, errors, documentService, $stateParams, $state, $translate) {
        $scope.params = {};
        $scope.params.Hours = "";
        $scope.params.SendMail = "false";
        $scope.emails = [];
        $scope.email = '';

        $scope.save = function (params) {
            $scope.params.Id = $stateParams.id;
            if ($scope.emails.length == 0 && params.SendMail == "true") {
                $scope.shareForm.$setSubmitted();
                errors.showError('SelectEmail');
                return false;
            }
            $scope.params.mailRecipients = $scope.emails.join(", ");

            if (!$scope.shareForm.$valid) {
                $scope.shareForm.$setSubmitted();
                errors.showError('VerifyFormData');
                return false;
            }

            return documentService.share(params).then(function (link) {
                if (params.SendMail == "false") {
                    $scope.CopyToClipboard(link);
                } else {
                    $translate(['SendMailOk'])
                        .then(function (translated) {
                            errors.showSuccess(translated.SendMailOk + ": " + link).then(function () {
                                $state.goBack('document-advanced-find');
                            });
                        });
                }
            }, function (error) {
                errors.showError(error);
            });
        };

        $scope.cancel = function () {
            $state.goBack();
        };

        $scope.CopyToClipboard = function (textToClipboard) {

            var success = true;
            if (window.clipboardData) { // Internet Explorer
                window.clipboardData.setData("Text", textToClipboard);
            }
            else {
                // create a temporary element for the execCommand method
                var forExecElement = $scope.CreateElementForExecCommand(textToClipboard);

                /* Select the contents of the element 
                    (the execCommand for 'copy' method works on the selection) */
                $scope.SelectContent(forExecElement);

                var supported = true;

                // UniversalXPConnect privilege is required for clipboard access in Firefox
                try {
                    if (window.netscape && netscape.security) {
                        netscape.security.PrivilegeManager.enablePrivilege("UniversalXPConnect");
                    }

                    // Copy the selected content to the clipboard
                    // Works in Firefox and in Safari before version 5
                    success = document.execCommand("copy", false, null);
                }
                catch (e) {
                    success = false;
                }

                // remove the temporary element
                document.body.removeChild(forExecElement);
            }

            if (success) {
                $translate(['CopyLinkSucces'])
                         .then(function (translated) {
                             errors.showSuccess(translated.CopyLinkSucces + ": " + textToClipboard).then(function () {
                                 $state.goBack('document-advanced-find');
                             });
                         });
            }
            else {

                $translate(['CopyLinkFail'])
                       .then(function (translated) {
                           errors.showSuccess(translated.CopyLinkFail + ": " + textToClipboard).then(function () {
                               $state.goBack('document-advanced-find');
                           });
                       });
            }
        }

        $scope.CreateElementForExecCommand = function (textToClipboard) {
            var forExecElement = document.createElement("div");
            // place outside the visible area
            forExecElement.style.position = "absolute";
            forExecElement.style.left = "-10000px";
            forExecElement.style.top = "-10000px";
            // write the necessary text into the element and append to the document
            forExecElement.textContent = textToClipboard;
            document.body.appendChild(forExecElement);
            // the contentEditable mode is necessary for the  execCommand method in Firefox
            forExecElement.contentEditable = true;

            return forExecElement;
        }

        $scope.SelectContent = function (element) {
            // first create a range
            var rangeToSelect = document.createRange();
            rangeToSelect.selectNodeContents(element);

            // select the contents
            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(rangeToSelect);
        }

        $scope.existValue = function (emails, email) {
            if (emails && emails.length > 0) {
                for (var i = 0; emails.length > i; i++) {
                    if (emails[i] == email) {
                        return true;
                    }
                }
            }

            return false;
        }

        $scope.addOption = function ($event) {
            // para que no ejecute el post al apretar enter
            $event.stopPropagation();

            if (!$scope.shareForm.inputMail.$valid) {
                errors.showError('InvalidEmail');
                return;
            }

            if ($scope.email != '' && !$scope.existValue($scope.emails, $scope.email)) {
                $scope.emails.push($scope.email);
                $scope.email = '';
            }
        }

        $scope.removeValue = function (item) {
            var indexOf = -1;
            for (var i = 0; i < $scope.emails.length; i++) {
                if ($scope.emails[i] === item) {
                    indexOf = i;
                    break;
                }
            }

            if (indexOf >= 0) {
                $scope.emails.splice(indexOf, 1);
            }
        }


    }
        ]);


})();